import { useQuery } from '@tanstack/react-query';
import { auditApi } from '../api/audit';
import type { AuditFilters } from '../api/audit';

export function useAuditLogs(filters: AuditFilters = {}) {
  return useQuery({
    queryKey: ['audits', filters],
    queryFn:  () => auditApi.list(filters),
    staleTime: 30_000,
  });
}

export function useAuditLog(id: number | null) {
  return useQuery({
    queryKey: ['audits', id],
    queryFn:  () => auditApi.find(id!),
    enabled:  id !== null,
    staleTime: 60_000,
  });
}

/** Returns a display-friendly event label for a raw event string. */
export function useAuditEventLabel(event: string): string {
  const labels: Record<string, string> = {
    'shop.installed':    'Shop Installed',
    'shop.uninstalled':  'Shop Uninstalled',
    'shop.updated':      'Shop Updated',
    'settings.updated':  'Settings Updated',
    'sync.triggered':    'Sync Triggered',
    'sync.completed':    'Sync Completed',
    'sync.failed':       'Sync Failed',
    'api_key.created':   'API Key Created',
    'api_key.revoked':   'API Key Revoked',
    'plan.changed':      'Plan Changed',
    'webhook.received':  'Webhook Received',
    'model.created':     'Record Created',
    'model.updated':     'Record Updated',
    'model.deleted':     'Record Deleted',
  };
  return labels[event] ?? event;
}
